import type { BookingTicket } from '~/types/booking'
import { formatAppointmentCode } from '~/utils/booking/ticketCode'
import { ensureTicketFonts, renderTicketCanvas } from '~/utils/booking/ticketCanvas'

function triggerDownload(href: string, filename: string) {
  const link = document.createElement('a')
  link.href = href
  link.download = filename
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  link.remove()
}

function canvasToBlob(canvas: HTMLCanvasElement): Promise<Blob> {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob)
      else reject(new Error('blob'))
    }, 'image/png')
  })
}

export function useTicketImage() {
  const generating = ref(false)
  const error = ref('')

  async function download(ticket: BookingTicket) {
    if (!import.meta.client) return
    generating.value = true
    error.value = ''
    const filename = `رسید-${formatAppointmentCode(ticket.code)}.png`
    try {
      await ensureTicketFonts()
      const scale = Math.max(2, Math.round((window.devicePixelRatio || 1) * 2))
      const canvas = renderTicketCanvas(ticket, scale)
      const png = await canvasToBlob(canvas)
      const href = URL.createObjectURL(png)
      triggerDownload(href, filename)
      window.setTimeout(() => URL.revokeObjectURL(href), 1500)
    }
    catch {
      error.value = 'دانلود تصویر ممکن نشد. از صفحه اسکرین‌شات بگیرید.'
    }
    finally {
      generating.value = false
    }
  }

  return { generating, error, download }
}
